import { classNames, React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Formik, Form as FormikForm } from 'formik';
import { styles } from './Form.scss';

const cx = classNames.bind(styles);

const Form = ({ children, className, display, ...props }) => {
  const classes = cx(
    'c-form',
    { [`c-form--display-${display}`]: !!display },
    className,
  );
  return (
    <Formik {...props}>
      {formikProps => (
        <FormikForm className={classes}>{children(formikProps)}</FormikForm>
      )}
    </Formik>
  );
};

Form.propTypes = {
  fieldProps: PropTypes.object,
  className: PropTypes.string,
  display: PropTypes.oneOf(['flex', 'contents']),
  children: PropTypes.any,
  onSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  validationSchema: PropTypes.object,
};

Form.defaultProps = {
  display: 'flex',
};

export { Form };
